import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getPromotePageData } from './api';
import type { PromotePageDataLoadErrorCode } from './types';

export const {
	Context: PromotePageDataContext,
	Provider: PromotePageDataContextProvider,
	useContext: usePromotePageData,
	useAsyncData: usePromotePageDataFromApi,
	prefetchAsyncData: prefetchPromotePageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PromotePageDataContext',
	dataProperty: 'pageData',
	hasUserData: true,
	hookDeps: ({ slug, countryCode, locale, stateCode }) => [slug, countryCode, locale, stateCode],
	getData: getPromotePageData,
	getUniqueId: ({ slug }) => slug,
	errorHandler: pageDataErrorHandler<PromotePageDataLoadErrorCode>(),
});

export type { HeroFeedItem } from './types';
